import axios from "axios";
import { Toast } from "mand-mobile";
import { Indicator } from "mint-ui";
import { getCookie } from "@/assets/utils/common.js"
import { setEncrypt } from "./authentication"


// 超时时间
axios.defaults.timeout = 30000;
// axios.defaults.showloading = true;
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";


if (process.env && process.env.NODE_ENV != "development") {
    axios.defaults.baseURL = process.env.VUE_APP_LOGOUT_URL;
    console.log(axios.defaults.baseURL)
}


let _Loading = {
    open() {
        Indicator.open({
            fullscreen: true,
            text: "加载中..",
            type: "spinner",
            size: 50,
            textColor: "#fff"
        });
        // Toast.loading('加载中...', 0, true)
    },
    close() {
        // Toast.hide()
        Indicator.close();
    }
};

let count = 0;
// http请求拦截器
axios.interceptors.request.use(
    config => {
        // 是否隐藏loading
        config.data ? config.data.hideloading = false : config.data = { hideloading: false };
        // console.log(config)
        // config.headers.brand = "yili";
        if (config.method != "get") {
            const openId = getCookie("openId") || ""; //oc63ewgcyeG8W5_21pn9edmwibMw,,,,,,oc63ews8AHH5YgzffK-fR6qTTxE0
            openId && (config.data.openId = openId);
        }
        if(!getCookie('openId')){
          // window.location.href="https://activeuat.feihe.com/fission-video/fissionVideo?openId=skip"
        }
        if (!config.data.hideloading) {
            _Loading.open();
            count++;
        }
        config.headers.sign = setEncrypt();
        // console.log(config)
        return config;
    },
    error => {
        _Loading.close();
        // setTimeout(() => {
        Toast.info("请求超时:" + error.toString(), 1000);
        // },10)
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    response => {
        count--;
        if (count === 0) {
            _Loading.close();
        }

        if (response.data.status == "0" || response.data.status == '-20' ) {
            return Promise.resolve(response.data);
        } else {
            // Toast.info(response.data.msg  || "获取数据失败", 1500);
            return Promise.reject(response.data.msg)
        }
    },
    // 服务器状态码不是2开头的的情况,这里可以跟你们的后台开发人员协商好统一的错误状态码  ,然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    error => {
        _Loading.close();
        count = 0;
        // setTimeout(() => {
        // console.log(error)
        Toast.info("网络请求失败", 1000);
        // },10)
        return Promise.reject(error.response);
    }
);
export default axios;



// WEBPACK FOOTER //
// ./src/assets/axios/index.js